/** 门户主站地址（SSO 登录跳转目标） */

export const PORTAL_HOME_URL =
  import.meta.env.VITE_PORTAL_HOME_URL ??
  (import.meta.env.DEV ? "http://localhost:8080/" : "https://www.oran.cn/");

/** 子应用在门户注册的 clientId，门户据此识别来源并配置回调地址 */
export const OAUTH_CLIENT_ID =
  import.meta.env.VITE_OAUTH_CLIENT_ID ?? "portal-a";

/** 登录跳转标识（门户据此展示登录页并回调） */
export const OAUTH_LOGIN_TAG =
  import.meta.env.VITE_OAUTH_LOGIN_TAG ?? "oranai-prompt";
